export const LEAD_SAVE = 'LEAD_SAVE';
export const RESET_SAVE = 'RESET_SAVE';
export const PETITIONER_SAVE = 'PETITIONER_SAVE';
export const RESET_PETITIONER_SAVE = 'RESET_PETITIONER_SAVE';
export const I_129_EXTRACTION_LENGTH = 'I_129_EXTRACTION_LENGTH';
export const ORGANIZATION_DATA = 'ORGANIZATION_DATA';
